module.exports = __webpack_public_path__ + "static/media/19-2.9ad82b58.mp3";